// Vehicle data for GarageIQ selector
// Structured as: makes -> models -> years with available trims

// Helper: generate array of years from start to end (inclusive)
function yr(start, end = 2024) {
  const years = [];
  for (let y = end; y >= start; y--) years.push(y);
  return years;
}

export const vehicleData = {
  Honda: {
    Civic: {
      years: yr(1990),
      trims: ['DX', 'LX', 'EX', 'Si', 'Sport', 'EX-L', 'Touring', 'Type R'],
    },
    Accord: {
      years: yr(1990),
      trims: ['DX', 'LX', 'EX', 'EX-L', 'SE', 'VP', 'Sport', 'Touring', 'Hybrid'],
      engines: [
        { id: '4cyl', label: '2.0L i-VTEC 4-Cylinder', yearRange: [2003, 2012] },
        { id: 'v6', label: '3.0L V6', yearRange: [2003, 2012] },
      ],
    },
    'CR-V': {
      years: yr(1997),
      trims: ['LX', 'EX', 'EX-L', 'Touring', 'Hybrid'],
    },
    Pilot: {
      years: yr(2003),
      trims: ['LX', 'EX', 'EX-L', 'Touring', 'Elite', 'Black Edition'],
    },
    Odyssey: {
      years: yr(1995),
      trims: ['LX', 'EX', 'EX-L', 'Touring', 'Elite'],
    },
    Ridgeline: {
      years: yr(2006),
      trims: ['Sport', 'RTL', 'RTL-E', 'Black Edition'],
    },
    'HR-V': {
      years: yr(2016),
      trims: ['LX', 'Sport', 'EX', 'EX-L'],
    },
    Passport: {
      years: yr(2019),
      trims: ['Sport', 'EX-L', 'Touring', 'Elite', 'TrailSport'],
    },
    Element: {
      years: yr(2003, 2011),
      trims: ['LX', 'EX', 'EX-P', 'SC'],
    },
    Prelude: {
      years: yr(1992, 2001),
      trims: ['Base', 'Si', 'VTEC', 'Type SH'],
    },
    'S2000': {
      years: yr(2000, 2009),
      trims: ['Base', 'CR'],
    },
  },
  Toyota: {
    Camry: {
      years: yr(1990),
      trims: ['DX', 'LE', 'SE', 'XSE', 'XLE', 'TRD', 'Hybrid'],
    },
    Corolla: {
      years: yr(1990),
      trims: ['DX', 'LE', 'SE', 'XLE', 'XSE', 'Hybrid'],
    },
    RAV4: {
      years: yr(1996),
      trims: ['Base', 'LE', 'XLE', 'XLE Premium', 'TRD Off-Road', 'Adventure', 'Limited', 'Hybrid', 'Prime'],
    },
    Tacoma: {
      years: yr(1995),
      trims: ['Base', 'SR', 'SR5', 'TRD Sport', 'TRD Off-Road', 'Limited', 'TRD Pro'],
    },
    Tundra: {
      years: yr(2000),
      trims: ['SR', 'SR5', 'Limited', 'Platinum', '1794', 'TRD Pro', 'Capstone'],
    },
    Highlander: {
      years: yr(2001),
      trims: ['Base', 'LE', 'XLE', 'XSE', 'Limited', 'Platinum', 'Hybrid'],
    },
    '4Runner': {
      years: yr(1990),
      trims: ['Base', 'SR5', 'SR5 Premium', 'TRD Sport', 'TRD Off-Road', 'Limited', 'TRD Pro'],
    },
    Prius: {
      years: yr(2001),
      trims: ['Base', 'Two', 'Three', 'Four', 'Five', 'Prime LE', 'Prime XLE', 'Prime Limited'],
    },
    Sienna: {
      years: yr(1998),
      trims: ['CE', 'LE', 'XLE', 'SE', 'Limited', 'Platinum', 'Hybrid'],
    },
    Supra: {
      years: [...yr(2020), ...yr(1993, 1998)],
      trims: ['2.0', '3.0', '3.0 Premium', 'A91', 'Base', 'Sport', 'Turbo'],
    },
    Sequoia: {
      years: yr(2001),
      trims: ['SR5', 'Limited', 'Platinum', 'TRD Pro', 'Capstone'],
    },
    'Land Cruiser': {
      years: yr(1990),
      trims: ['Base', 'GX', 'VX'],
    },
  },
  Ford: {
    'F-150': {
      years: [...yr(1990), ...yr(1980, 1986)],
      trims: ['Regular', 'XL', 'XLT', 'Lariat', 'King Ranch', 'Platinum', 'Limited', 'Raptor', 'Custom', 'Ranger', 'Ranger XLT', 'Ranger Lariat'],
      engines: [
        { id: '4.9l-i6-bullnose', label: '4.9L (300) I6 (Bullnose)', yearRange: [1980, 1986] },
        { id: '4.2l-v8-bullnose', label: '4.2L (255) V8 (Bullnose, 1980-81)', yearRange: [1980, 1981] },
        { id: '5.0l-v8-bullnose', label: '5.0L (302) V8 (Bullnose)', yearRange: [1980, 1986] },
        { id: '5.8l-v8-bullnose', label: '5.8L (351W/351M) V8 (Bullnose)', yearRange: [1980, 1986] },
      ],
    },
    Mustang: {
      years: yr(1990),
      trims: ['Base', 'LX', 'GT', 'Cobra', 'EcoBoost', 'EcoBoost Premium', 'GT Premium', 'Mach 1', 'Shelby GT350', 'Shelby GT500'],
    },
    Explorer: {
      years: yr(1991),
      trims: ['Base', 'XL', 'XLT', 'Eddie Bauer', 'Limited', 'ST', 'Platinum', 'King Ranch', 'Timberline'],
    },
    Escape: {
      years: yr(2001),
      trims: ['XLS', 'XLT', 'S', 'SE', 'SE Sport', 'SEL', 'Titanium', 'Plug-In Hybrid'],
    },
    Bronco: {
      years: [...yr(2021), ...yr(1992, 1996)],
      trims: ['Base', 'Big Bend', 'Black Diamond', 'Outer Banks', 'Badlands', 'Wildtrak', 'Everglades', 'Raptor', 'XL', 'XLT', 'Eddie Bauer'],
    },
    Ranger: {
      years: [...yr(2019), ...yr(1993, 2011)],
      trims: ['XL', 'XLT', 'Edge', 'Sport', 'FX4', 'Lariat', 'Raptor'],
    },
    Maverick: {
      years: yr(2022),
      trims: ['XL', 'XLT', 'Lariat', 'Tremor'],
    },
    Expedition: {
      years: yr(1997),
      trims: ['XLT', 'Eddie Bauer', 'Limited', 'King Ranch', 'Platinum', 'Timberline'],
    },
    'F-250': {
      years: [...yr(1990), ...yr(1980, 1986)],
      trims: ['XL', 'XLT', 'Lariat', 'King Ranch', 'Platinum', 'Tremor', 'Custom', 'Ranger', 'Ranger XLT'],
      engines: [
        { id: '4.9l-i6-bullnose', label: '4.9L (300) I6 (Bullnose)', yearRange: [1980, 1986] },
        { id: '5.8l-v8-bullnose', label: '5.8L (351) V8 (Bullnose)', yearRange: [1980, 1986] },
        { id: '6.6l-v8-bullnose', label: '6.6L (400) V8 (Bullnose 1980)', yearRange: [1980, 1980] },
        { id: '7.5l-v8-bullnose', label: '7.5L (460) V8 (Bullnose)', yearRange: [1980, 1986] },
        { id: '6.9l-diesel-bullnose', label: '6.9L IDI Diesel V8 (Bullnose)', yearRange: [1983, 1986] },
      ],
    },
    'F-350': {
      years: [...yr(1990), ...yr(1980, 1986)],
      trims: ['XL', 'XLT', 'Lariat', 'King Ranch', 'Platinum', 'Limited', 'Custom', 'Ranger', 'Ranger XLT'],
      engines: [
        { id: '4.9l-i6-bullnose', label: '4.9L (300) I6 (Bullnose)', yearRange: [1980, 1986] },
        { id: '5.8l-v8-bullnose', label: '5.8L (351) V8 (Bullnose)', yearRange: [1980, 1986] },
        { id: '7.5l-v8-bullnose', label: '7.5L (460) V8 (Bullnose)', yearRange: [1980, 1986] },
        { id: '6.9l-diesel-bullnose', label: '6.9L IDI Diesel V8 (Bullnose)', yearRange: [1983, 1986] },
      ],
    },
    Focus: {
      years: yr(2000, 2018),
      trims: ['S', 'SE', 'SEL', 'Titanium', 'ST', 'RS', 'Electric'],
    },
    Fusion: {
      years: yr(2006, 2020),
      trims: ['S', 'SE', 'SEL', 'Titanium', 'Hybrid SE', 'Hybrid Titanium', 'Energi'],
    },
  },
  Chevrolet: {
    Silverado: {
      years: yr(1990),
      trims: ['C/K', 'WT', 'Custom', 'LT', 'RST', 'LTZ', 'High Country', 'ZR2'],
    },
    Equinox: {
      years: yr(2005),
      trims: ['LS', 'LT', 'LTZ', 'RS', 'Premier'],
    },
    Malibu: {
      years: yr(1997, 2023),
      trims: ['LS', 'LT', 'LTZ', 'RS', 'Premier'],
    },
    Tahoe: {
      years: yr(1995),
      trims: ['LS', 'LT', 'RST', 'Z71', 'Premier', 'High Country'],
    },
    Traverse: {
      years: yr(2009),
      trims: ['LS', 'LT', 'RS', 'Premier', 'High Country', 'Activ'],
    },
    Colorado: {
      years: yr(2004),
      trims: ['WT', 'LT', 'Z71', 'Trail Boss', 'ZR2'],
    },
    Camaro: {
      years: [...yr(2010), ...yr(1990, 2002)],
      trims: ['LS', 'LT', '1SS', '2SS', 'ZL1', 'Z28', 'IROC-Z'],
    },
    Suburban: {
      years: yr(1990),
      trims: ['C1500', 'K1500', 'LS', 'LT', 'Premier', 'High Country'],
    },
    Blazer: {
      years: [...yr(2019), ...yr(1990, 2005)],
      trims: ['L', 'LT', 'RS', 'Premier', 'SS'],
    },
    Impala: {
      years: yr(2000, 2020),
      trims: ['LS', 'LT', 'LTZ', 'Premier'],
    },
    'S-10': {
      years: yr(1990, 2004),
      trims: ['Base', 'LS', 'SS', 'ZR2', 'Xtreme'],
    },
  },
  Dodge: {
    Ram: {
      years: yr(1990, 2010),
      trims: ['ST', 'SLT', 'Laramie', 'Sport', 'TRX'],
    },
    Challenger: {
      years: yr(2008),
      trims: ['SXT', 'GT', 'R/T', 'R/T Scat Pack', 'SRT 392', 'SRT Hellcat', 'SRT Super Stock', 'Demon'],
    },
    Charger: {
      years: [...yr(2006), ...yr(1990, 1993)],
      trims: ['SXT', 'GT', 'R/T', 'R/T Scat Pack', 'SRT 392', 'SRT Hellcat', 'SRT Super Stock'],
    },
    Durango: {
      years: yr(1998),
      trims: ['SXT', 'GT', 'Citadel', 'R/T', 'SRT 392', 'SRT Hellcat'],
    },
    Dakota: {
      years: yr(1990, 2011),
      trims: ['Base', 'SLT', 'Sport', 'Laramie', 'R/T'],
    },
    Viper: {
      years: yr(1992, 2017),
      trims: ['RT/10', 'GTS', 'SRT-10', 'SRT', 'ACR'],
    },
  },
  Ram: {
    '1500': {
      years: yr(2009),
      trims: ['Tradesman', 'Big Horn', 'Lone Star', 'Laramie', 'Rebel', 'Limited', 'TRX'],
    },
    '2500': {
      years: yr(2010),
      trims: ['Tradesman', 'Big Horn', 'Laramie', 'Power Wagon', 'Limited'],
    },
    '3500': {
      years: yr(2010),
      trims: ['Tradesman', 'Big Horn', 'Laramie', 'Limited'],
    },
  },
  Jeep: {
    Wrangler: {
      years: yr(1987),
      trims: ['S', 'Base', 'Sport', 'SE', 'Sahara', 'Rubicon', 'X', 'Unlimited Sport', 'Unlimited Sahara', 'Unlimited Rubicon', '392', '4xe'],
      engines: [
        { id: '2.4l-i4', label: '2.4L I4', yearRange: [2003, 2006] },
        { id: '4.0l-i6', label: '4.0L I6', yearRange: [1997, 2006] },
      ],
    },
    'Grand Cherokee': {
      years: yr(1993),
      trims: ['Laredo', 'Sport', 'Limited', 'Overland', 'Summit', 'Trailhawk', 'SRT', 'Trackhawk'],
    },
    Cherokee: {
      years: [...yr(2014), ...yr(1990, 2001)],
      trims: ['Sport', 'Classic', 'Country', 'Limited', 'Latitude', 'Altitude', 'Trailhawk', 'Overland'],
    },
    Gladiator: {
      years: yr(2020),
      trims: ['Sport', 'Sport S', 'Willys', 'Overland', 'Rubicon', 'Mojave'],
    },
    'Liberty': {
      years: yr(2002, 2012),
      trims: ['Sport', 'Sport Jet', 'Limited', 'Renegade'],
    },
    Compass: {
      years: yr(2007),
      trims: ['Sport', 'Latitude', 'Altitude', 'Limited', 'Trailhawk'],
    },
    Patriot: {
      years: yr(2007, 2017),
      trims: ['Sport', 'Latitude', 'Limited'],
    },
  },
  GMC: {
    Sierra: {
      years: yr(1990),
      trims: ['C/K', 'SL', 'SLE', 'SLT', 'AT4', 'Denali'],
    },
    Yukon: {
      years: yr(1992),
      trims: ['SLE', 'SLT', 'AT4', 'Denali'],
    },
    Terrain: {
      years: yr(2010),
      trims: ['SLE', 'SLT', 'AT4', 'Denali'],
    },
    Acadia: {
      years: yr(2007),
      trims: ['SLE', 'SLT', 'AT4', 'Denali'],
    },
    Canyon: {
      years: yr(2004),
      trims: ['SLE', 'SLT', 'AT4', 'Denali', 'AT4X'],
    },
    Envoy: {
      years: yr(2002, 2009),
      trims: ['SLE', 'SLT', 'Denali'],
    },
    Jimmy: {
      years: yr(1990, 2001),
      trims: ['SLE', 'SLT'],
    },
    Sonoma: {
      years: yr(1991, 2004),
      trims: ['SLS', 'SLE', 'SLT'],
    },
  },
  BMW: {
    '3 Series': {
      years: yr(1990),
      trims: ['318i', '320i', '323i', '325i', '328i', '330i', '335i', '340i', 'M340i', 'M3'],
    },
    '5 Series': {
      years: yr(1990),
      trims: ['525i', '528i', '530i', '535i', '540i', '545i', '550i', 'M550i', 'M5'],
    },
    'X3': {
      years: yr(2004),
      trims: ['2.5i', '3.0i', 'sDrive28i', 'xDrive28i', 'xDrive30i', 'M40i', 'M'],
    },
    'X5': {
      years: yr(2000),
      trims: ['3.0i', '4.4i', 'sDrive40i', 'xDrive40i', 'xDrive45e', 'M50i', 'M'],
    },
    'X1': {
      years: yr(2013),
      trims: ['sDrive28i', 'xDrive28i', 'M35i'],
    },
    'M3': {
      years: yr(1990),
      trims: ['Base', 'Competition', 'CS', 'CSL'],
    },
    'Z3': {
      years: yr(1996, 2002),
      trims: ['1.9', '2.3', '2.8', '3.0', 'M Roadster', 'M Coupe'],
    },
  },
  Mercedes: {
    'C-Class': {
      years: yr(1994),
      trims: ['C 220', 'C 230', 'C 280', 'C 300', 'C 320', 'C 350', 'C 400', 'AMG C 43', 'AMG C 63', 'AMG C 63 S'],
    },
    'E-Class': {
      years: yr(1994),
      trims: ['E 300', 'E 320', 'E 350', 'E 400', 'E 430', 'E 450', 'E 500', 'AMG E 53', 'AMG E 63 S'],
    },
    'GLE': {
      years: yr(1998),
      trims: ['ML 320', 'ML 430', 'GLE 350', 'GLE 450', 'GLE 580', 'AMG GLE 53', 'AMG GLE 63 S'],
    },
    'S-Class': {
      years: yr(1992),
      trims: ['S 320', 'S 420', 'S 430', 'S 500', 'S 550', 'S 600', 'AMG S 63', 'AMG S 65'],
    },
    'G-Class': {
      years: yr(2002),
      trims: ['G 500', 'G 550', 'G 63 AMG', 'G 65 AMG'],
    },
  },
  Subaru: {
    Outback: {
      years: yr(1995),
      trims: ['Base', 'Premium', 'Limited', 'Touring', 'XT', 'Wilderness'],
    },
    Forester: {
      years: yr(1998),
      trims: ['L', 'S', 'X', 'XT', 'Base', 'Premium', 'Sport', 'Limited', 'Touring', 'Wilderness'],
    },
    Impreza: {
      years: yr(1993),
      trims: ['L', 'LX', 'Base', 'Premium', 'Sport', 'Limited', 'RS'],
    },
    WRX: {
      years: yr(2002),
      trims: ['Base', 'Premium', 'Limited', 'GT', 'STI', 'STI Limited', 'STI Sport'],
    },
    Crosstrek: {
      years: yr(2013),
      trims: ['Base', 'Premium', 'Sport', 'Limited', 'Wilderness', 'Hybrid'],
    },
    Legacy: {
      years: yr(1990),
      trims: ['Base', 'Premium', 'Sport', 'Limited', 'Touring', 'GT'],
    },
    'BRZ': {
      years: yr(2013),
      trims: ['Premium', 'Limited', 'tS', 'Series.Gray', 'Series.Yellow'],
    },
  },
  Nissan: {
    Altima: {
      years: yr(1993),
      trims: ['XE', 'GXE', 'SE', 'GLE', 'S', 'SV', 'SR', 'SL', 'Platinum'],
    },
    Rogue: {
      years: yr(2008),
      trims: ['S', 'SV', 'SL', 'Platinum', 'Rock Creek'],
    },
    Frontier: {
      years: yr(1998),
      trims: ['XE', 'SE', 'S', 'SV', 'Pro-4X', 'SL'],
    },
    Pathfinder: {
      years: yr(1990),
      trims: ['XE', 'SE', 'LE', 'S', 'SV', 'SL', 'Platinum', 'Rock Creek'],
    },
    Sentra: {
      years: yr(1990),
      trims: ['E', 'XE', 'GXE', 'SE', 'GLE', 'S', 'SV', 'SR', 'SL'],
    },
    Maxima: {
      years: yr(1990),
      trims: ['GXE', 'SE', 'GLE', 'SL', 'SR', 'SV', 'Platinum'],
    },
    Xterra: {
      years: yr(2000, 2015),
      trims: ['XE', 'SE', 'S', 'X', 'Off-Road', 'Pro-4X'],
    },
    '350Z': {
      years: yr(2003, 2009),
      trims: ['Base', 'Touring', 'Performance', 'Track', 'Enthusiast', 'Nismo'],
    },
    '370Z': {
      years: yr(2009, 2020),
      trims: ['Base', 'Sport', 'Touring', 'Nismo'],
    },
    Armada: {
      years: yr(2004),
      trims: ['SE', 'LE', 'SV', 'SL', 'Platinum'],
    },
    Titan: {
      years: yr(2004),
      trims: ['S', 'SV', 'Pro-4X', 'SL', 'Platinum'],
    },
  },
  Hyundai: {
    Elantra: {
      years: yr(1993),
      trims: ['Base', 'GL', 'GLS', 'SE', 'SEL', 'Sport', 'N Line', 'Limited', 'N'],
    },
    Tucson: {
      years: yr(2005),
      trims: ['GLS', 'GL', 'SE', 'Value', 'SEL', 'N Line', 'XRT', 'Limited', 'Hybrid', 'PHEV'],
    },
    Sonata: {
      years: yr(1990),
      trims: ['GL', 'GLS', 'SE', 'SEL', 'SEL Plus', 'N Line', 'Limited', 'Hybrid'],
    },
    'Santa Fe': {
      years: yr(2001),
      trims: ['GLS', 'LX', 'SE', 'SEL', 'XRT', 'Calligraphy', 'Limited', 'Hybrid', 'PHEV'],
    },
    Accent: {
      years: yr(1995),
      trims: ['GL', 'GS', 'SE', 'GLS', 'S', 'SE', 'SEL'],
    },
    Tiburon: {
      years: yr(1997, 2008),
      trims: ['Base', 'GS', 'GT', 'SE', 'GTP'],
    },
    Genesis: {
      years: yr(2009, 2016),
      trims: ['2.0T', '3.8', '5.0 R-Spec', '5.0 Ultimate'],
    },
  },
  Volkswagen: {
    Jetta: {
      years: yr(1990),
      trims: ['GL', 'GLS', 'GLX', 'TDI', 'S', 'SE', 'SEL', 'GLI', 'R-Line'],
    },
    Golf: {
      years: yr(1990),
      trims: ['GL', 'GLS', 'GTI', 'TDI', 'S', 'SE', 'R'],
    },
    Passat: {
      years: yr(1990),
      trims: ['GL', 'GLS', 'GLX', 'S', 'SE', 'SEL', 'R-Line'],
    },
    Tiguan: {
      years: yr(2009),
      trims: ['S', 'SE', 'SEL', 'SEL R-Line'],
    },
    Beetle: {
      years: yr(1998, 2019),
      trims: ['GL', 'GLS', 'GLX', 'S', 'SE', 'Final Edition'],
    },
  },
  Mazda: {
    'Mazda3': {
      years: yr(2004),
      trims: ['Sport', 'Touring', 'Grand Touring', 'Premium', 'Turbo'],
    },
    'Mazda6': {
      years: yr(2003),
      trims: ['Sport', 'Touring', 'Grand Touring', 'Signature'],
    },
    'CX-5': {
      years: yr(2013),
      trims: ['Sport', 'Touring', 'Grand Touring', 'Signature', 'Carbon Edition'],
    },
    'MX-5 Miata': {
      years: yr(1990),
      trims: ['Base', 'Sport', 'Club', 'Grand Touring', 'RF Club', 'RF Grand Touring'],
    },
    'RX-7': {
      years: yr(1990, 2002),
      trims: ['Base', 'Touring', 'R1', 'R2', 'Efini'],
    },
  },
  Pontiac: {
    Firebird: {
      years: yr(1990, 2002),
      trims: ['Base', 'Formula', 'Trans Am', 'Ram Air', 'Firehawk'],
    },
    'Grand Prix': {
      years: yr(1990, 2008),
      trims: ['SE', 'GT', 'GTP', 'GXP'],
    },
    'Grand Am': {
      years: yr(1990, 2005),
      trims: ['SE', 'GT'],
    },
    Aztek: {
      years: yr(2001, 2005),
      trims: ['Base', 'GT'],
    },
    'G6': {
      years: yr(2005, 2010),
      trims: ['Base', 'GT', 'GTP', 'GXP'],
    },
  },
  Saturn: {
    Vue: {
      years: yr(2002, 2010),
      trims: ['Base', 'Ion', 'XE', 'XR', 'Green Line'],
    },
    Ion: {
      years: yr(2003, 2007),
      trims: ['Base', 'Quad Coupe', 'Red Line'],
    },
  },
  Chrysler: {
    '300': {
      years: yr(2005),
      trims: ['Touring', 'Limited', 'S', 'C', 'SRT-8', 'SRT8', 'Platinum'],
    },
    Sebring: {
      years: yr(1995, 2010),
      trims: ['JX', 'JXi', 'LX', 'LXi', 'Limited', 'GTC'],
    },
    PT_Cruiser: {
      years: yr(2001, 2010),
      trims: ['Base', 'Classic', 'Limited', 'GT', 'Touring'],
    },
    Pacifica: {
      years: yr(2017),
      trims: ['Touring', 'Touring L', 'Touring L Plus', 'Limited', 'Pinnacle', 'Hybrid'],
    },
  },
  Acura: {
    TL: {
      years: yr(1999, 2014),
      trims: ['Base', 'S-Type', 'Type-S', 'Technology', 'SH-AWD'],
    },
    MDX: {
      years: yr(2001),
      trims: ['Base', 'Technology', 'Advance', 'Sport Hybrid', 'A-Spec', 'Type S'],
    },
    RSX: {
      years: yr(2002, 2006),
      trims: ['Base', 'Type-S'],
    },
    Integra: {
      years: [...yr(2023), ...yr(1990, 2001)],
      trims: ['RS', 'LS', 'GS', 'GS-R', 'Type R', 'Base', 'A-Spec', 'A-Spec Tech'],
    },
    NSX: {
      years: [...yr(2017), ...yr(1991, 2005)],
      trims: ['Base', 'Type S'],
    },
  },
  Lexus: {
    IS: {
      years: yr(2001),
      trims: ['IS 200', 'IS 300', 'IS 250', 'IS 350', 'IS 500', 'F Sport'],
    },
    ES: {
      years: yr(1992),
      trims: ['ES 250', 'ES 300', 'ES 330', 'ES 350', 'ES 300h'],
    },
    GX: {
      years: yr(2003),
      trims: ['Base', 'Premium', 'Luxury', 'Overtrail'],
    },
    RX: {
      years: yr(1999),
      trims: ['RX 300', 'RX 330', 'RX 350', 'RX 400h', 'RX 450h', 'F Sport'],
    },
    LX: {
      years: yr(1996),
      trims: ['LX 450', 'LX 470', 'LX 570', 'LX 600'],
    },
  },
  Infiniti: {
    G35: {
      years: yr(2003, 2008),
      trims: ['Base', 'Sport', 'x'],
    },
    G37: {
      years: yr(2008, 2013),
      trims: ['Base', 'Sport', 'Journey', 'x'],
    },
    Q50: {
      years: yr(2014),
      trims: ['Pure', 'Luxe', 'Sport', 'Red Sport 400'],
    },
    FX35: {
      years: yr(2003, 2008),
      trims: ['Base'],
    },
    QX56: {
      years: yr(2004, 2013),
      trims: ['Base'],
    },
  },
};

// Get sorted list of all makes
export function getMakes() {
  return Object.keys(vehicleData).sort();
}

// Get models for a given make
export function getModels(make) {
  if (!make || !vehicleData[make]) return [];
  return Object.keys(vehicleData[make]).sort();
}

// Get years for a given make + model (already sorted descending)
export function getYears(make, model) {
  if (!make || !model || !vehicleData[make]?.[model]) return [];
  return vehicleData[make][model].years;
}

// Get trims for a given make + model
export function getTrims(make, model) {
  if (!make || !model || !vehicleData[make]?.[model]) return [];
  return vehicleData[make][model].trims;
}

// Get available engines for a given make + model + year
export function getEngines(make, model, year) {
  if (!make || !model || !year || !vehicleData[make]?.[model]) return [];
  const engines = vehicleData[make][model].engines;
  if (!engines) return [];
  const y = parseInt(year);
  return engines.filter(e => y >= e.yearRange[0] && y <= e.yearRange[1]);
}

// Format a vehicle object into a display string
export function formatVehicle(vehicle) {
  if (!vehicle?.year || !vehicle?.make || !vehicle?.model) return null;
  const trim = vehicle.trim ? ` ${vehicle.trim}` : '';
  const engine = vehicle.engine ? ` (${vehicle.engineLabel || vehicle.engine.toUpperCase()})` : '';
  return `${vehicle.year} ${vehicle.make} ${vehicle.model}${trim}${engine}`;
}
